module.exports = __webpack_public_path__ + "static/img/4.622a94e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/eng/4.png
// module id = J6cO
// module chunks = 0